<script setup lang="ts">
import QRCode from 'qrcode';

interface IQRCodeProps {
  url: string;
}
const props = defineProps<IQRCodeProps>();
const qr = ref();

onMounted(async () => {
  qr.value = await QRCode.toDataURL(props.url);
});
</script>

<template>
  <img class="rounded-xl overflow-hidden" :src="qr" :alt="url" />
</template>

<style scoped lang="scss"></style>
